export const API_URL = "https://worx-assistant-function-app.azurewebsites.net/api/"
